export enum InputType {
	DatePicker = 'DatePicker',
	Dropdown = 'Dropdown',
	Menu = 'Menu',
	MegaMenu = 'MegaMenu',
	ChangeAttestation = 'ChangeAttestation',
	ApplyFilters = 'ApplyFilters',
	ClearAllFilters = 'ClearAllFilters',
}
